// Packages
import type { TablePaginationConfig } from 'antd';

// Default pagination settings. Not in Table.tsx: the navigation, the page header and `useTable` need
// the first page number on every screen, and importing it from there pulled the whole table (and its
// select) into the first load of pages that have no table, the sign-in page included.
export const paginationSettings: TablePaginationConfig = {
  current: 1,
  pageSize: 25,
  showSizeChanger: true,
  placement: ['bottomStart'],
  pageSizeOptions: ['25', '50', '100'],
};
